
import React, { useState } from "react";
import {
  Box,
  Chip,
  Collapse,
  Divider,
  Link,
  List,
  ListItem,
  ListItemSecondaryAction,
  Paper,
  Typography,
  useTheme
} from "@material-ui/core";
import { KeyboardArrowDown, KeyboardArrowRight } from "@material-ui/icons";

const changeLog = () => (
  <iframe src={window.trcAppSettings.authoringBundlePath.replace("dist/en", "whatsnew.html")} />
);

export default () => {
  const [hover, setHover] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showLoginVersion, setShowLoginVersion] = useState(true);

  window.setShowLoginVersion = setShowLoginVersion;
  
  const active = Boolean(anchorEl);
  const theme = useTheme();

  const {
    versionSettings,
    loginSettings
  } = window.trcAppSettings;

  const settingsToUse = (showLoginVersion ? loginSettings : versionSettings);

  if (!settingsToUse) {
    return false;
  }

  const {
    appName,
    createdOn,
    version,
    versionType
  } = settingsToUse;

  const versionTypeName = ({
    "prod": "Production",
    "integration": "Integration",
    "alpha": "Alpha",
    "stage": "Stage",
    "staging": "Staging",
    "local": "Local",
  })[versionType] || versionType;

  const showChanges = window.isStudio && versionType != "local";
  const index = version.indexOf("-");
  const versionRaw = index < 0 ? version : version.substring(0, index);
  const timestamp = new Date(createdOn);

  return (
    <Box
      style={{
        transition: "all .5s",
        position: "absolute",
        bottom: 10,
        left: 10,
        display: "flex",
        flexDirection: "column",
        gap: 10,
        opacity: 0.25,
        width: 335,
        ...(hover && {
          opacity: 1
        })
      }}
      onMouseOverCapture={() => setHover(true)}
      onMouseOutCapture={() => setHover(false)}
    >
      <Collapse in={active}>
        <Paper elevation={0} variant="outlined" style={{ overflow: "hidden" }}>
          <List disablePadding>
            <Section
              title={
                <Box
                  display="flex"
                  gridGap={theme.spacing(1)}
                  alignItems="center"
                  style={{
                    display: "flex",
                    gridGap: theme.spacing(1),
                    alignItems: "center"
                  }}
                >
                  SimGate {appName}
                  <Chip size="small" style={{ paddingLeft: "5px", fontSize: "8px" }} label={version} />
                </Box>
              }
              show={true}
              open
            >
              {([
                {
                  displayName: "Version type",
                  value: versionTypeName,
                  show: true
                },
                {
                  displayName: "Build timestamp",
                  show: true,
                  value: versionType === "local" ? "-" : `${timestamp.toDateString().substring(4, timestamp.toDateString().lastIndexOf(" "))}, ${timestamp.getFullYear()}, ${timestamp.toLocaleTimeString().substring(0, timestamp.toLocaleTimeString().lastIndexOf(":"))} ${timestamp.toLocaleTimeString().substr(-2)}`
                },
                {
                  displayName: "Changelog",
                  show: showChanges,
                  value: (
                    <Link
                      href={window.trcAppSettings.authoringBundlePath.replace("dist/en", "whatsnew.html")}
                      target="_blank"
                    >
                      Open
                    </Link>
                  )
                },
                {
                  displayName: "Changes since last alpha",
                  show: showChanges,
                  value: (
                    <Link
                      href={window.trcAppSettings.authoringBundlePath.replace("dist/en", "since-alpha.html")}
                      target="_blank"
                    >
                      Open
                    </Link>
                  )
                }
              ]).map(({ displayName, show, value },  index) => {
                return (
                  <Box key={index} style={{
                    display: show ? "flex" : "none"
                  }}>
                    <Box style={{
                      flexBasis: "50%"
                    }}>
                      <Typography>
                        <b>{displayName}</b>
                      </Typography>
                    </Box>
                    <Box style={{
                      flexBasis: "50%",
                      justifyContent: "flex-end",
                      display: "flex"
                    }}>
                      <Typography>{value}</Typography>
                    </Box>
                  </Box>
                );
              })}
            </Section>
            <Divider />
            <Section title="What's new" show={showChanges}>{showChanges ? changeLog : <></>}</Section>
          </List>
        </Paper>
      </Collapse>

      <Chip
        onClick={(e) => {
          if (active) {
            setAnchorEl(null);
          } else {
            setAnchorEl(e.currentTarget);
          }
        }}
        label={`${appName} ${versionRaw}`}
        style={{ width: "min-content" }}
      />
    </Box>
  );
};

const Section = ({ title, children, open, show }) => {
  const [_open, setOpen] = useState(open);
  return (
    <Box>
      <ListItem
        button
        onClick={() => setOpen((prev) => !prev)}
        style={{ display: show ? "flex" : "none", paddingLeft: "15px", paddingRight: "15px" }}
        disableGutters
      >
        <Box px={2}>
          <Typography variant="h5">{title}</Typography>
          <ListItemSecondaryAction>
            {_open ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
          </ListItemSecondaryAction>
        </Box>
      </ListItem>
      <Collapse in={_open}>
        <Divider />
        <Box p={2} style={{
          display: "flex",
          padding: "12px",
          gap: "5px",
          flexDirection: "column"
        }}>
          {children}
        </Box>
      </Collapse>
    </Box>
  );
};
